//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomListItem from "../custom/CustomListItem.vue"
import IconImage from "../IconImage.vue"
import ScrollToMessageMixin from "../chat/ScrollToMessageMixin"

export default {
    name: "media-search-links",
    props: {
        messages: {
            type: Object,
            default: {}
        },
    },    
    mixins: [ScrollToMessageMixin],
    components: {
        IconImage,
        CustomListItem
    },
    data() {
        return {};
    },
    methods: {
        makeHeader(item) {
            const firstLink = item.msg[0];
            if (item.linkItemHeader.substr(0, 10) !== firstLink.substr(0, 10))
                return item.linkItemHeader;
            else return false;
        },
        makeTitle(links) {
            let title = "";
            links.forEach(link => {
                title += link + "\n";
            });
            return title;
        },
        getPhoto(cid) {
            return this.$store.getters["contacts/getMergedContactById"](cid).photo || ""
        },
        getFio(cid) {
            return this.$store.getters["contacts/getMergedContactById"](cid).fio || ""
        },
        onContextMenu(e, message) {
            this.$emit("mediasearch-common-contextmenu", { e, message });
        },
        scrollToMessage(e, id) {
            if (e.type === "click" && id) this.scrollingToElement(id);
        },
        async openLinkContextMenu(e) {
            let { event, link } = e.detail;
            let handlers = [];
            handlers.push({
                item_name: this.$t("open-link"),
                handler: this.openUrlLink,
                data: link
            });
            handlers.push({
                item_name: this.$t("copy-link"),
                handler: this.copyToClipboard,
                data: link
            });
            this.cmOpen(event, handlers, "right-bottom");
        },
        openUrlLink(link) {
            window.openLink(link);
        },
        copyToClipboard(data = "") {
            this.$copyText(data);
        }
    }
};
